module.exports = "li.row_pickcenter i {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 40%;\r\n}\r\n\r\n.cursor {\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/repeatorder/repeatorderlist/repeatorderlist.component.css
// module id = ./src/app/repeatorder/repeatorderlist/repeatorderlist.component.css
// module chunks = main